import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import LoginForm from './form';
import styles from './style/index.module.less';

function Login() {
  useEffect(() => {
    // window.location.href = casdoor.getSigninUrl();
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Footer, null))));
}

Login.displayName = 'LoginPage';
export default Login;